import styled from 'styled-components';
import { IconClose } from '../../../design-system/components/Icons';

import {
  colorAttention100Default,
  colorBackgroundDisabled,
  colorBorderActive,
  colorTertiary50Lighter,
  colorTertiary100Default,
} from '../../design-tokens';
import { borderRadius, spacing1, spacing2 } from 'lib/mortar';

const tabFocus = `
  outline: 0;

  &:focus-visible {
    box-shadow: 0 0 0 4px ${colorAttention100Default};
  }
`;

const IconButton = styled.button<
  StyledButton & {
    type?: 'button' | 'submit' | 'reset';
  }
>`
  display: flex;
  cursor: pointer;
  background: none;
  border: none;
  margin: 0;
  padding: ${spacing2};
  ${tabFocus};
`;

const IconCloseWrapper = styled.div<StyledDiv>`
  padding: ${spacing1};
  border-radius: ${borderRadius(3)};
  background-color: ${colorBackgroundDisabled};
  &:hover {
    background-color: ${colorTertiary50Lighter};
    svg,
    svg path {
      fill: ${colorTertiary100Default};
    }
  }
`;

interface ButtonProps {
  onClick: () => void;
  className?: string;
}

const CloseButtonUnstyled = ({ onClick, className }: ButtonProps) => (
  <IconButton
    className={className}
    onClick={onClick}
    type="button"
    aria-label="Close"
  >
    <IconCloseWrapper>
      <IconClose size="xs" color={colorBorderActive} />
    </IconCloseWrapper>
  </IconButton>
);

export const CloseButton = styled(CloseButtonUnstyled)``;
